'use client';

import React, { useState } from 'react';
import { NavDropdown as RBNavDropdown } from 'react-bootstrap';
import { CaretIcon } from '@/componentv2/icons';
import './navDropdown.scss';
import AppLink from '@/componentv2/AppLink/AppLink';
import Badge from '@/componentv2/badge/badge';
import { getNavLinkAriaLabel } from '@/componentv2/nav/getNavLinkAriaLabel';

interface NavDropdownItem {
  id: string;
  label: string;
  href: string;
  icon?: React.ComponentType;
  subtitle?: string;
  badge?: string;
}

interface NavDropdownProps {
  title: string;
  items: NavDropdownItem[];
  variant?: 'products' | 'more';
  id: string;
  isWide?: boolean;
}

const NavDropdown: React.FC<NavDropdownProps> = ({
  title,
  items,
  variant = 'more',
  id,
  isWide = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <RBNavDropdown
      title={
        <span className="d-flex align-items-center">
          {title}
          <CaretIcon height={16} className="caret-icon" />
        </span>
      }
      id={id}
      className={`nav-dropdown nav-dropdown--${variant}${isWide ? ' nav-dropdown--big-bang' : ''}`}
      show={isOpen}
      onToggle={(nextShow) => setIsOpen(nextShow)}
    >
      {isOpen &&
        items.map((item) => {
          const hasIcon = item.icon && item.subtitle;

          return (
            <AppLink
              key={item.id}
              href={item.href}
              intent="navigation"
              className="nav-dropdown__item"
              aria-label={getNavLinkAriaLabel(item.label, item.badge)}
              onClick={handleLinkClick}
            >
              {hasIcon ? (
                <>
                  <span className="nav-dropdown__icon">
                    {item.icon && <item.icon />}
                  </span>
                  <span className="nav-dropdown__text">
                    {item.label}
                    <span className="nav-dropdown__subtitle">
                      {item.subtitle}
                    </span>
                  </span>
                </>
              ) : (
                <span className="nav-dropdown__text">
                  {item.label}
                  {item.badge && (
                    <Badge
                      className="nav-dropdown__title-badge"
                      label={item.badge}
                      ariaHidden
                    />
                  )}
                </span>
              )}
            </AppLink>
          );
        })}
    </RBNavDropdown>
  );
};

export default NavDropdown;
